import React from "react";
import { Icon } from "semantic-ui-react";
import { Button } from "../button/Button";
import cn from "classnames";
import "./buttonWithIcon.scss";
import { type StrictButtonProps } from "semantic-ui-react/dist/commonjs/elements/Button/Button";

type Props = {
  id: string;
  label?: string;
  iconName?: string;
  onClick: () => void;
  blur?: boolean;
} & StrictButtonProps;

/** @deprecated This component is deprecated. Use Button directly passing icon param */
function ButtonWithIcon(props: Props) {
  const { id, label, children, iconName, icon, className, disabled, primary, onClick, blur, ...rest } = props;
  const customClassName = label ? "with-label" : null;
  return (
    <Button
      id={id}
      className={cn("button-with-icon", className)}
      onClick={(e) => {
        onClick();
        if (blur) e.currentTarget.blur();
      }}
      disabled={disabled}
      primary={primary}
      {...rest}
    >
      <Icon className={`${iconName} ${customClassName}`} size="large" disabled={disabled} />
      <span className="title">{label}</span>
      {children}
    </Button>
  );
}

export default ButtonWithIcon;
